import {
  kBudgetedHeadcount,
  kSalaryRollup,
  kPositionBudgetRollup,
  enumObjClassNames
} from "@coreapp/constants";

const POSITION_ONLY_FIELDS = [kBudgetedHeadcount, kSalaryRollup, kPositionBudgetRollup];

/**
 * Get the object class name for a given field ID based on chart metadata.
 * Used to determine whether a metric field belongs to the position or box (employee) class,
 * which is needed to look up the correct fieldDef for rendering and value retrieval.
 *
 * @param {string} fieldID - The field ID to look up
 * @param {Object} chartMetadata - The chart metadata containing formulas
 * @param {string} objClassName - The default object class name to use
 * @returns {string} The object class name (position or box)
 */
export const getObjClassNameForField = (fieldID, chartMetadata, objClassName) => {
  if (POSITION_ONLY_FIELDS.includes(fieldID)) {
    return enumObjClassNames.position;
  }

  const formulas = chartMetadata?.["formulas"] ?? [];
  const formula = formulas.find(f => f.name === fieldID);

  if (formula) {
    return formula.targetType === "position" ? enumObjClassNames.position : enumObjClassNames.box;
  }

  return objClassName;
};
